module.exports = __webpack_public_path__ + "static/temoignage2-6f0ddee91eb2cd384fb83491918e3cd9.png";